import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DashboardService } from '@page/dashboard/helper/dashboard.service';
import { KycStage } from '@page/dashboard/helper/dashboard.types';
import { SidebarService } from './helper/sidebar.service';
import { MenuPanel, SideMenu } from './helper/sidebar.types';
import { CommonModule } from '@angular/common';
import { ConnectBankService } from '@page/connect-bank-account/helper/connect-bank-account.service';


@Component({
  standalone:true,
  imports:[
    CommonModule,
    RouterModule,
  ],
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SidebarComponent implements OnInit {
  sidemenuData: SideMenu[];
  url: any;
  selectedIndex: any;
  labelImg: any;
  kycData: KycStage;
  constructor(
    public _Router: Router,
    public bsModalRef: BsModalRef,
    private _DashboardService: DashboardService,
    private _SidebarService: SidebarService,
    public _ConnectBankService: ConnectBankService,
    

  ) { }

  ngOnInit() {
    this._SidebarService.menuPanel$.subscribe((data: MenuPanel | null) => {
      if (data) {
        this.sidemenuData = data.sideMenu;
        this.labelImg = data.label_image;
        
      }
    })

    this._DashboardService.kycStatus$.subscribe((data: any) => {
      if (data) {
        this.kycData = data as KycStage;
      }
    })
  }

  opneModal(value: any, title: any): void {
    //   if (value == 0) {
    //     if (this.modalService.getModalsCount() < 1) {
    //       this.bsModalRef = this.modalService.show(ServiceDownDialogComponent, {
    //         ignoreBackdropClick: true,
    //       });

    //       const modalBackdrop = document.querySelector('.modal-backdrop');
    //       const customModal = document.querySelector('modal-container');
    //       if (modalBackdrop && customModal) {
    //         modalBackdrop.classList.add('custom-backdrop');
    //         customModal.classList.add('custom-modal');
    //       }
    //     }
    //   } else {
    //     this.bsModalRef.hide();
    //   }
  }
}
